
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface SwapFormActionsProps {
  isSubmitting: boolean;
  insufficientCredits: boolean;
  reagentId: string;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}

const SwapFormActions: React.FC<SwapFormActionsProps> = ({ 
  isSubmitting, 
  insufficientCredits,
  reagentId,
  onSubmit 
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-end space-x-4 mt-8">
      <Button
        type="button"
        variant="outline"
        onClick={() => navigate(`/reagents/${reagentId}`)}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      
      <Button 
        type="submit" 
        disabled={isSubmitting || insufficientCredits}
        className="min-w-[120px]"
      >
        {isSubmitting ? (
          <span className="flex items-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin" />
            Sending...
          </span>
        ) : (
          "Request Swap"
        )}
      </Button>
    </div>
  );
};

export default SwapFormActions;
